import {
  LdapPouzivatelItem,
  OrganizaciaLdapPouzivateliaMapExternalApi,
} from 'ciselniky-frontend-ts-axios';
import apiConfiguration from '../../configuration/apiConfiguration';
import { ciselnikyPrefixPath } from '../../configuration/apiConfigurationConstants';
import { ClientResponse } from '../../../model/ClientResponse';

const client = new OrganizaciaLdapPouzivateliaMapExternalApi(apiConfiguration(ciselnikyPrefixPath));

// eslint-disable-next-line import/prefer-default-export
export const fetchOrganizaciaLdapPouzivatelMap = async (ids: string[]):
  Promise<ClientResponse<{ [key: string]: Array<LdapPouzivatelItem> }>> => {
  const {
    data,
    status,
  } = await client.getPouzivatelMapByOrgUuids(ids);
  return {
    data,
    responseCode: status,
  };
};
